/* eslint-disable @shopify/typescript/prefer-singular-enums */
import { usePosthog } from '../use-posthog'

enum EventProperties {
  PROPERTIES_START_NEW_ACTION = 'properties_start_new_action',
  PROPERTIES_CREATE_NEW_ACTION = 'properties_create_new_action',
  PROPERTIES_PUBLISH_NEW_ACTION = 'properties_publish_new_action',
  PROPERTIES_REPUBLISH_ACTION = 'properties_republish_action',
  PROPERTIES_ARCHIVE_ACTION = 'properties_archive_action',
  DATASHEET_PUBLIC_SHARE_ACTION = 'datasheet_public_share_action'
}

export const useEventProperties = () => {
  const { trackEvent } = usePosthog()

  const propertiesStartNewAction = (where: 'home' | 'properties') => {
    trackEvent({
      name: EventProperties.PROPERTIES_START_NEW_ACTION,
      eventProperties: {
        displayName: 'Iniciar crear propiedad',
        where
      }
    })
  }

  const propertiesCreateNewAction = (kind: 'admin' | 'broker') => {
    trackEvent({
      name: EventProperties.PROPERTIES_CREATE_NEW_ACTION,
      eventProperties: {
        displayName: 'Crear propiedad',
        kind
      }
    })
  }

  const propertiesPublishNewAction = () => {
    trackEvent({
      name: EventProperties.PROPERTIES_PUBLISH_NEW_ACTION,
      eventProperties: {
        displayName: 'Publicar propiedad'
      }
    })
  }

  const propertiesRepublishAction = () => {
    trackEvent({
      name: EventProperties.PROPERTIES_REPUBLISH_ACTION,
      eventProperties: {
        displayName: 'Republicar propiedad'
      }
    })
  }

  const propertiesArchiveAction = (where: 'label' | 'difusion') => {
    trackEvent({
      name: EventProperties.PROPERTIES_ARCHIVE_ACTION,
      eventProperties: {
        displayName: 'Archivar propiedad',
        where
      }
    })
  }

  const datasheetPublicShareAction = (
    kind: 'public' | 'broker' | 'reshared'
  ) => {
    trackEvent({
      name: EventProperties.DATASHEET_PUBLIC_SHARE_ACTION,
      eventProperties: {
        displayName: 'Compartir ficha de propiedad',
        kind
      }
    })
  }

  return {
    propertiesStartNewAction,
    propertiesCreateNewAction,
    propertiesPublishNewAction,
    propertiesRepublishAction,
    propertiesArchiveAction,
    datasheetPublicShareAction
  }
}
